module.exports = __webpack_public_path__ + "img/88.a5bde8a9.jpg";